import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Gem, CheckCircle2, XCircle } from "lucide-react";

export const AdminSuscripcionesTab = () => {
  const [pagos, setPagos] = useState([]);
  const [filtro, setFiltro] = useState("pendiente");
  const load = () => api.get("/suscripcion/pendientes", { params: { estado: filtro } }).then(r => setPagos(r.data.pagos)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [filtro]); // eslint-disable-line react-hooks/exhaustive-deps

  const aprobar = async (id) => {
    try { const { data } = await api.patch(`/suscripcion/${id}/aprobar`); toast.success(`Plan activado hasta ${data.plan_vence.slice(0, 10)}`); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const rechazar = async (id) => {
    const motivo = window.prompt("Motivo del rechazo (se notifica al comercio):", "El comprobante no coincide con el monto");
    if (motivo === null) return;
    try { await api.patch(`/suscripcion/${id}/rechazar`, { motivo }); toast.success("Comprobante rechazado"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div data-testid="admin-suscripciones">
      <div className="bg-zinc-900 text-white rounded-sm p-5 flex flex-wrap items-center gap-4">
        <Gem className="w-6 h-6 text-[#D4FF00]" />
        <div className="flex-1">
          <div className="font-display font-bold">PLAN INTEGRAL · $299 MXN / 30 días</div>
          <div className="text-xs text-white/60 font-mono mt-0.5">Cuenta: Ricardo Zermeño Mejia · BBVA · CLABE 012320004618064241</div>
        </div>
        <div className="flex bg-white/10 rounded-sm overflow-hidden text-xs">
          {["pendiente", "aprobado", "rechazado", "todos"].map(f => <button key={f} data-testid={`susc-filtro-${f}`} onClick={() => setFiltro(f)} className={`px-3 h-9 capitalize ${filtro === f ? "bg-white text-zinc-900" : ""}`}>{f}</button>)}
        </div>
      </div>
      <div className="overline text-zinc-500 mt-6 mb-3">Comprobantes ({pagos.length})</div>
      {pagos.length === 0 ? (
        <div className="border border-dashed border-zinc-300 rounded-sm p-10 text-center text-zinc-400 text-sm">Sin comprobantes {filtro !== "todos" ? filtro + "s" : ""}</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {pagos.map(p => (
            <div key={p.id} data-testid={`susc-${p.id}`} className="bg-white border border-zinc-200 rounded-sm p-4 grid grid-cols-[120px_1fr] gap-4">
              <a href={p.comprobante_url} target="_blank" rel="noreferrer"><img src={p.comprobante_url} alt="comprobante" className="w-full aspect-[3/4] object-cover rounded-sm border border-zinc-200" /></a>
              <div className="text-sm">
                <div className="flex items-center gap-2"><div className="font-display font-bold flex-1">{p.nombre_local}</div>
                  <Badge className={`border-0 ${p.estado === "aprobado" ? "bg-emerald-100 text-emerald-700" : p.estado === "rechazado" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"}`}>{p.estado}</Badge></div>
                <div className="text-xs text-zinc-500">{p.ciudad} · {p.telefono || "sin tel."} · {new Date(p.created_at).toLocaleString()}</div>
                <div className="mt-1">Monto <b>${p.monto}</b>{p.referencia ? ` · Ref ${p.referencia}` : ""}</div>
                {p.nota && <div className="text-xs text-zinc-500">{p.nota}</div>}
                <div className="text-xs text-zinc-500 mt-1">Plan actual vence: {p.plan_vence ? p.plan_vence.slice(0, 10) : "—"}</div>
                {p.estado === "pendiente" && (
                  <div className="flex gap-2 mt-3">
                    <Button size="sm" data-testid={`susc-aprobar-${p.id}`} onClick={() => aprobar(p.id)} className="rounded-sm bg-emerald-500 hover:bg-emerald-600"><CheckCircle2 className="w-4 h-4 mr-1" /> Aprobar +30 días</Button>
                    <Button size="sm" variant="outline" data-testid={`susc-rechazar-${p.id}`} onClick={() => rechazar(p.id)} className="rounded-sm"><XCircle className="w-4 h-4 mr-1" /> Rechazar</Button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
